// src/components/ProductCard.jsx
import React, { useState } from "react";
// import "./ProductCard.css";

const ProductCard = ({ product, onOpen }) => {
  const [activeSize, setActiveSize] = useState(product.sizes[0]);

  return (
    <div className="card">
      {/* Image container WITHOUT background */}
      <div className="img-wrapper">
        <img
          className="card-img"
          src={product.images[activeSize]}
          alt={product.name}
        />
      </div>

      <div className="card-body">
        <p className="rating">⭐ {product.rating} ({product.reviews} reviews)</p>

        <h3 className="product-name">
          {product.name} – {activeSize}
        </h3>

        <div className="price-row">
          <span className="new-price">₹ {product.price[activeSize]}</span>
          {product.oldPrice && (
            <>
              <span className="old-price">₹ {product.oldPrice[activeSize]}</span>
              <span className="offer">50% off</span>
            </>
          )}
        </div>

        <div className="sizes">
          {product.sizes.map((s) => (
            <button
              key={s}
              onClick={() => setActiveSize(s)}
              className={activeSize === s ? "size-btn active" : "size-btn"}
            >
              {s}
            </button>
          ))}
        </div>

        <button className="view-btn" onClick={() => onOpen(product, activeSize)}>
          View Details
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
